module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_mail-e617ded94d1eb89670a88a26acedb89b.svg";